import { render } from "./More-info-about-club-card.vue?vue&type=template&id=7b7c0162&scoped=true"
import script from "./More-info-about-club-card.vue?vue&type=script&lang=js"
export * from "./More-info-about-club-card.vue?vue&type=script&lang=js"

import "./More-info-about-club-card.vue?vue&type=style&index=0&id=7b7c0162&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b7c0162"]])

export default __exports__